import React from 'react'
import styled from 'styled-components'
import { Container, Block, Skeleton } from './styles'
import { Box } from 'grommet';

const pageWidth = props => props.theme.global.size.pageWidth;

const MainContainer = styled(Box)`
width: ${pageWidth};
margin: 0 auto;
padding: 0 40px;
flex-direction: row;

@media only screen and (min-device-width: 280px)  and (max-device-width: 540px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
  padding: 0 16px;
}
`

const OrderDetailsContainer = styled(Box)`
  flex: 70%;
`

const OrderSummaryContainer = styled(Box)`
  flex: 30%;
`

const OrderItemLine = styled(Block)`
  padding: 0px;
  height: 200px;
  flex-direction: column;

  ${({ theme }) => theme.mediaQuery.up('tablet-landscape')} {
    flex-direction: row;
  }
`

const OrderItemDetails = styled(Block)`
  width: 100%;
  padding: 2px;
  flex-direction: row;

  ${({ theme }) => theme.mediaQuery.up('tablet-landscape')} {
    width: 70%;
    flex-direction: column;
  }
`

const OrderItemImage = styled(Block)`
  width: 100px;
  height: 100px;
`

const OrderItemTextContainer = styled(Block)`
  width: 50%;
`

const OrderItemText = styled(Block)`
  padding: 0px;

  ${({ theme }) => theme.mediaQuery.up('tablet-landscape')} {
    padding: 2px;
  }
`

const ActionContainer = styled(Block)`
  width: 100%;
  padding: 12px;
  height: 102px;
  flex-direction: column;

  ${({ theme }) => theme.mediaQuery.up('tablet-landscape')} {
    width: 30%;
    padding: 2px;
    height: 54px;
    flex-direction: row;
  }
`

const MyAccountOrderDetails = () => (
  <MainContainer>
    <OrderDetailsContainer>
      <Block direction="row">
        <Block direction="column">
          <Skeleton height="58px" />
        </Block>
      </Block>
      <Block direction="row">
        <Block direction="column">
          <Skeleton height="204px" />
        </Block>
      </Block>
      {[1, 2, 3].map(index => (
        <OrderItemLine key={index}>
          <OrderItemDetails>
            <Block direction="row">
              <OrderItemImage direction="column">
                <Skeleton height="100px" />
              </OrderItemImage>
              <OrderItemTextContainer direction="column">
                <Block direction="row">
                  <OrderItemText direction="column">
                    <Skeleton height="20px" />
                  </OrderItemText>
                </Block>
                <Block direction="row">
                  <OrderItemText direction="column">
                    <Skeleton height="20px" />
                  </OrderItemText>
                </Block>
                <Block direction="row">
                  <OrderItemText direction="column">
                    <Skeleton height="20px" />
                  </OrderItemText>
                </Block>
                <Block direction="row">
                  <OrderItemText direction="column">
                    <Skeleton height="20px" />
                  </OrderItemText>
                </Block>
              </OrderItemTextContainer>
            </Block>
          </OrderItemDetails>
          <ActionContainer direction="column">
            <Block>
              <Skeleton height="282px" />
            </Block>
          </ActionContainer>
        </OrderItemLine>
      ))}
    </OrderDetailsContainer>
    <OrderSummaryContainer>
      <Block direction="row">
        <Block direction="column">
          <Skeleton height="450px" />
        </Block>
      </Block>
    </OrderSummaryContainer>
  </MainContainer>
)

export default MyAccountOrderDetails